import { render, staticRenderFns } from "./productInstall.vue?vue&type=template&id=4ef586cc&scoped=true"
import script from "./productInstall.vue?vue&type=script&lang=js"
export * from "./productInstall.vue?vue&type=script&lang=js"
import style0 from "./productInstall.vue?vue&type=style&index=0&id=4ef586cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef586cc",
  null
  
)

export default component.exports